import { render } from "./IconEllipsis.vue?vue&type=template&id=33fc5332"
import script from "./IconEllipsis.vue?vue&type=script&lang=js"
export * from "./IconEllipsis.vue?vue&type=script&lang=js"

import "./IconEllipsis.vue?vue&type=style&index=0&id=33fc5332&lang=scss"
script.render = render

export default script